import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InvitationsService {
  private invitationAcceptedSubject = new Subject<string>();
  invitationAccepted$ = this.invitationAcceptedSubject.asObservable();

  emitInvitationAccepted(token: string): void {
    this.invitationAcceptedSubject.next(token);
  }
}
